import { ReactElement } from 'react';
import { CONTENT_COLLECTION_ENTRY, useCollectionEntry } from '@client/content/hooks';
import classNames from 'classnames';
import { Props } from './index';
import './Brand.scss';

const CONVERT_BRAND_TO_ID_REGEXP = /[^a-z0-9]/gi;

export const Brand = ({
  brand,
  className,
}: Props): ReactElement => {
  const brandId = brand.toLowerCase().replace(CONVERT_BRAND_TO_ID_REGEXP, '-') || '';
  const entry = useCollectionEntry(CONTENT_COLLECTION_ENTRY.brandPages, brandId);
  const { data, isLoaded } = entry;

  if (!isLoaded || !data) {
    return null;
  }
  const { data: content } = data;
  const { title, description, logo } = content;
  const logoUrl = logo?.url || null;

  return (
    <div className={classNames('Brand', className)}>
      {logoUrl && (
        <div className="Brand-Logo">
          <img src={logoUrl} alt={title} title={title} className="Brand-Image" />
        </div>
      )}

      <div className="Brand-Content">
        <h1 className="Brand-Name">{title}</h1>
        <div
          className="Brand-Description"
          dangerouslySetInnerHTML={{
            __html: description,
          }}
        />
      </div>
    </div>
  );
};
